import React, { useState, useEffect } from 'react';
import { FaArrowLeft, FaPlus, FaSync, FaExclamationTriangle, FaSignInAlt, FaUser, FaPaperPlane } from 'react-icons/fa';
import { forumService } from '../../api';
import DiscussionList from './DiscussionList';
import Discussion from './Discussion';
import Header from '../Header/Header';
import Footer from '../footer/Footer';
import './Forum.css';
import { Link, } from 'react-router-dom';
const Forum = () => {
  const [discussions, setDiscussions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedDiscussion, setSelectedDiscussion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [view, setView] = useState('list');
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    loadData();
    checkAuthentication();
  }, []);

  const checkAuthentication = () => {
    try {
      const token = localStorage.getItem('token');
      const userData = localStorage.getItem('user');
      
      if (token && userData) {
        const user = JSON.parse(userData);
        setCurrentUser(user);
      } else {
        setCurrentUser(null);
      }
    } catch (err) {
      console.error('Error checking authentication:', err);
      setCurrentUser(null);
    }
  };

  const loadData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('🔍 Début du chargement des données du forum...');
      
      const [discussionsData, categoriesData] = await Promise.all([
        forumService.getDiscussions(),
        forumService.getCategories()
      ]);
      
      // LOGS POUR DEBUG
      console.log('📊 Données discussions reçues:', discussionsData);
      console.log('📊 Catégories forum reçues:', categoriesData);
      
      if (categoriesData && Array.isArray(categoriesData)) {
        console.log('📊 Liste des catégories disponibles:');
        categoriesData.forEach((cat, index) => {
          console.log(`  ${index + 1}. ID: ${cat.id}, Nom: ${cat.name || cat.nom}`);
        });
      }
      
      // Normaliser les données
      const normalizedDiscussions = discussionsData.data || discussionsData || [];
      const normalizedCategories = categoriesData || [];
      
      setDiscussions(normalizedDiscussions);
      setCategories(normalizedCategories);
      
      console.log('✅ Chargement terminé:', {
        discussionsCount: normalizedDiscussions.length,
        categoriesCount: normalizedCategories.length
      });
      
    } catch (err) {
      console.error('❌ Erreur détaillée loadData:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status
      });
      setError(err.message || 'Erreur lors du chargement du forum');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectDiscussion = async (discussionId) => {
    try {
      setLoading(true);
      setError(null);
      const discussion = await forumService.getDiscussion(discussionId);
      setSelectedDiscussion(discussion.data || discussion);
      setView('discussion');
    } catch (err) {
      setError(err.message || 'Erreur lors du chargement de la discussion');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleBackToList = () => {
    setSelectedDiscussion(null);
    setView('list');
    loadData();
  };

  const handleCreateDiscussion = async (discussionData) => {
    try {
      if (!currentUser) {
        setError('Vous devez être connecté pour créer une discussion');
        return;
      }

      setError(null);
      
      const discussionToSend = {
        title: discussionData.title,
        content: discussionData.content,
        category_id: discussionData.category_id
      };
      
      console.log('📤 Envoi de la discussion:', discussionToSend);
      
      const response = await forumService.createDiscussion(discussionToSend);
      
      if (response.success) {
        console.log('✅ Discussion créée avec succès:', response.data);
        setView('list');
        loadData();
      } else {
        throw new Error(response.error || 'Erreur inconnue');
      }
    } catch (err) {
      console.error('❌ Erreur détaillée création discussion:', err);
      
      if (err.response) {
        if (err.response.status === 401) {
          setError('Session expirée. Veuillez vous reconnecter.');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setCurrentUser(null);
        } else if (err.response.status === 422) {
          const validationErrors = err.response.data.errors;
          const errorMessage = Object.values(validationErrors).flat().join(', ');
          setError(`Erreur de validation : ${errorMessage}`);
        } else if (err.response.data && err.response.data.message) {
          setError(err.response.data.message);
        } else {
          setError('Erreur lors de la création de la discussion');
        }
      } else {
        setError(err.message || 'Erreur lors de la création de la discussion');
      }
    }
  };

  const handleCreateReply = async (discussionId, content) => {
    try {
      if (!currentUser) {
        setError('Vous devez être connecté pour répondre');
        return;
      }

      setError(null);
      await forumService.createReply(discussionId, content);
      const updatedDiscussion = await forumService.getDiscussion(discussionId);
      setSelectedDiscussion(updatedDiscussion.data || updatedDiscussion);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        setError('Session expirée. Veuillez vous reconnecter.');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setCurrentUser(null);
      } else {
        setError(err.response?.data?.message || err.message || 'Erreur lors de l\'ajout de la réponse');
      }
      console.error(err);
    }
  };

  const handleLoginRedirect = () => {
    window.location.href = '/connexion';
  };

  const handleRefreshAuth = () => {
    checkAuthentication();
    if (currentUser) {
      setError(null);
    }
  };

  if (loading) {
    return (
      <div className="forum-container">
        <div className="forum-loading">
          <div className="loading-spinner"></div>
          <p>Chargement du forum...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bigcontainforum">
     <Header />
      <div className="forum-container">
         
        <div className="forum-header">
          <div className="header-content">
            <h1>Forum de discussion</h1>
            <p>Échangez et partagez vos connaissances avec la communauté</p>
            {currentUser && (
              <div className="user-welcome">
                <FaUser className="icon" />
                Connecté en tant que : <strong>{currentUser.name || currentUser.email}</strong>
                <button 
                  className="btn-refresh-auth" 
                  onClick={handleRefreshAuth}
                  title="Rafraîchir l'authentification"
                >
                  <FaSync className="icon" />
                </button>
              </div>
            )}
          </div>
             {view === 'list' && (
              <button 
                className="btn-create-discussion"
                onClick={() => {
                  if (!currentUser) {
                    setError('Vous devez être connecté pour créer une discussion');
                    return;
                  }
                  setView('create');
                }}
              >
                <FaPlus className="icon" />
                Nouvelle discussion
              </button>
            )}
          <div className="header-actions">
         
            {view !== 'list' && (
              <button 
                className="btn-back"
                onClick={handleBackToList}
              >
                <FaArrowLeft className="icon" />
                Retour à la liste
              </button>
            )}
          </div>
        </div>

        {error && (
          <div className="forum-error-message">
            <div className="error-icon">
              <FaExclamationTriangle />
            </div>
            <p>{error}</p>
            <div className="error-actions">
              <button className="btn-retry" onClick={handleRefreshAuth}>
                <FaSync className="icon" />
                Actualiser l'authentification
              </button>
              {!currentUser && (
              <Link to="/connexion">
           <button className="btn-login">
           <FaSignInAlt className="icon" />
              Se connecter
         </button>
         </Link>
              )}
            </div>
          </div>
        )}

        {!currentUser && !error && (
          <div className="auth-warning">
            <p>
              <strong>Attention :</strong> Vous n'êtes pas connecté. 
              <button 
                className="btn-login-link"
                onClick={handleLoginRedirect}
              >
                Connectez-vous
              </button>
              pour participer aux discussions.
            </p>
          </div>
        )}

        {/* Rendu conditionnel principal */}
        {view === 'list' && (
          <DiscussionList
            discussions={discussions}
            categories={categories}
            onSelectDiscussion={handleSelectDiscussion}
            currentUser={currentUser}
          />
        )}

        {view === 'discussion' && selectedDiscussion && (
          <Discussion
            discussion={selectedDiscussion}
            onCreateReply={handleCreateReply}
            onBack={handleBackToList}
            currentUser={currentUser}
          />
        )}

        {view === 'create' && (
          <div className="create-discussion-form">
            <div className="form-header">
              <h2>Créer une nouvelle discussion</h2>
              <p>Partagez votre question ou votre idée avec la communauté</p>
              {currentUser && (
                <div className="user-info">
                  <FaUser className="icon" />
                  Posté en tant que : <strong>{currentUser.name || currentUser.email}</strong>
                </div>
              )}
            </div>
            
            <form onSubmit={(e) => {
              e.preventDefault();
              
              if (!currentUser) {
                setError('Vous devez être connecté pour créer une discussion');
                return;
              }

              const formData = new FormData(e.target);
              
              const title = formData.get('title').trim();
              const content = formData.get('content').trim();
              const categoryId = formData.get('category_id');
              
              if (!title || !content || !categoryId) {
                setError('Veuillez remplir tous les champs obligatoires');
                return;
              }

              handleCreateDiscussion({
                title: title,
                content: content,
                category_id: parseInt(categoryId)
              });
            }}>
              <div className="form-group">
                <label htmlFor="title">Titre de la discussion *</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  required
                  maxLength="200"
                  placeholder="Donnez un titre clair à votre discussion"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="category">Catégorie *</label>
                <select id="category" name="category_id" required>
                  <option value="">Choisissez une catégorie</option>
                  {categories.map(category => (
                    <option key={category.id} value={category.id}>
                      {/* CORRIGÉ : Utiliser category.name (qui a été normalisé) */}
                      {category.name || category.nom}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="content">Contenu *</label>
                <textarea
                  id="content"
                  name="content"
                  rows="8"
                  required
                  maxLength="5000"
                  placeholder="Développez votre question ou votre idée ici..."
                  onChange={(e) => {
                    const counter = e.target.parentElement.querySelector('.char-counter');
                    if (counter) {
                      counter.textContent = `${e.target.value.length}/5000 caractères`;
                    }
                  }}
                ></textarea>
                <div className="char-counter">0/5000 caractères</div>
              </div>
              
              <div className="form-actions">
                <button type="button" className="btn-cancel" onClick={() => setView('list')}>
                  Annuler
                </button>
                <button type="submit" className="btn-submit" disabled={!currentUser}>
                  {currentUser ? (
                    <>
                      <FaPaperPlane className="icon" />
                      Publier la discussion
                    </>
                  ) : (
                    'Connexion requise'
                  )}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Forum;